import type { Kit } from '@/types/kit';

// Mock kit data based on existing product combinations
export const kits: Kit[] = [
  // ResMed Nasal Kit
  {
    id: 'resmed-11-nasal-kit',
    name: 'Kit ResMed Nasal',
    marca: 'ResMed',
    tipo: 'Nasal',
    descripcion: 'Kit completo con equipo AirSense 11 AutoSet y mascarilla nasal AirFit N20 para terapia CPAP premium.',
    imagen: 'https://buno1storage1account.blob.core.windows.net/www-buno/buno-tu-companero-cpap-35/airsense-11-apap-n20.png',
    shopifyHandle: 'cpap-auto-airsense-11-mascarilla-nasal-airfit-n20',
    bundleMapping: {
      equipmentId: 'resmed-airsense-11',
      maskId: 'resmed-airfit-n20',
      shopifyHandle: 'cpap-auto-airsense-11-mascarilla-nasal-airfit-n20',
      variants: {
        S: '47305579135188',
        M: '47305579167956',
        L: '47305579200724'
      }
    },
    components: [
      {
        id: 'airsense-11-autoset',
        name: 'AirSense 11 AutoSet',
        type: 'equipo',
        marca: 'ResMed',
        modelo: 'AirSense 11 AutoSet',
        caracteristicas: [
          'Algoritmo AutoSet con detección automática',
          'Función EPR para mayor comodidad',
          'HumidAir humidificador integrado',
          'Conectividad celular y Wi-Fi',
          'Reportes myAir detallados'
        ],
        imagen: 'https://buno1storage1account.blob.core.windows.net/www-buno/buno-tu-companero-cpap-35/airsense-11.jpg',
        conectividad: 'Wi-Fi + Celular',
        garantia: '1 año completa'
      },
      {
        id: 'airfit-n20',
        name: 'AirFit N20',
        type: 'mascarilla',
        marca: 'ResMed',
        modelo: 'AirFit N20 Nasal',
        caracteristicas: [
          'Tecnología InfinitySeal',
          'Marco minimalista',
          'Almohadilla UltraSoft',
          'Tubing giratorio 360°',
          'Campo visual despejado'
        ],
        imagen: 'https://buno1storage1account.blob.core.windows.net/www-buno/buno-tu-companero-cpap-35/N20 (Nasal) Edit.jpg',
        tipo: 'Nasal',
        compatibilidad: ['ResMed AirSense 10', 'Yuwell YH-680B']
      }
    ],
    beneficios: [
      'Tecnología ResMed con algoritmo AutoSet',
      'Mascarilla nasal de máxima comodidad',
      'Conectividad avanzada con reportes detallados',
      'Humidificación integrada para mayor confort',
      'Garantía completa de 1 año'
    ],
    recomendadoPara: [
      'Usuarios que respiran principalmente por nariz',
      'Personas que buscan Tecnología',
      'Usuarios que valoran reportes detallados'
    ],
    compatibleCon: ['Terapia APAP', 'Terapia CPAP', 'Monitoreo remoto']
  },

  // ResMed Oronasal Kit
  {
    id: 'resmed-11-oronasal-kit',
    name: 'Kit ResMed Oronasal',
    marca: 'ResMed',
    tipo: 'Oronasal',
    descripcion: 'Kit completo con equipo AirSense 11 AutoSet y mascarilla oronasal AirFit F20 para respiradores bucales.',
    imagen: 'https://buno1storage1account.blob.core.windows.net/www-buno/buno-tu-companero-cpap-35/airsense-11-apap-f20.png',
    shopifyHandle: 'cpap-auto-airsense-11-mascarilla-oronasal-airfit-f20',
    bundleMapping: {
      equipmentId: 'resmed-airsense-11',
      maskId: 'resmed-airfit-f20',
      shopifyHandle: 'cpap-auto-airsense-11-mascarilla-oronasal-airfit-f20',
      variants: {
        S: '47305577496788',
        M: '47305577529556',
        L: '47305577562324'
      }
    },
    components: [
      {
        id: 'airsense-11-autoset',
        name: 'AirSense 11 AutoSet',
        type: 'equipo',
        marca: 'ResMed',
        modelo: 'AirSense 11 AutoSet',
        caracteristicas: [
          'Algoritmo AutoSet con detección automática',
          'Función EPR para mayor comodidad',
          'HumidAir humidificador integrado',
          'Conectividad celular y Wi-Fi',
          'Reportes myAir detallados'
        ],
        imagen: 'https://buno1storage1account.blob.core.windows.net/www-buno/buno-tu-companero-cpap-35/airsense-11.jpg',
        conectividad: 'Wi-Fi + Celular',
        garantia: '1 año completa'
      },
      {
        id: 'airfit-f20',
        name: 'AirFit F20',
        type: 'mascarilla',
        marca: 'ResMed',
        modelo: 'AirFit F20 Oronasal',
        caracteristicas: [
          'Tecnología InfinitySeal',
          'Cobertura completa boca y nariz',
          'Almohadilla facial UltraSoft',
          'Válvula QuietAir anti-ruido',
          'Marco flexible adaptable'
        ],
        imagen: 'https://buno1storage1account.blob.core.windows.net/www-buno/buno-tu-companero-cpap-35/F20 (Oronasal) Edit.jpg',
        tipo: 'Oronasal',
        compatibilidad: ['ResMed AirSense 10', 'Yuwell YH-680B']
      }
    ],
    beneficios: [
      'Ideal para respiradores bucales o mixtos',
      'Tecnología ResMed con AutoSet',
      'Sellado óptimo para terapia efectiva',
      'Conectividad avanzada con monitoreo',
      'Comodidad durante toda la noche'
    ],
    recomendadoPara: [
      'Usuarios que respiran por boca durante el sueño',
      'Personas con obstrucción nasal frecuente',
      'Usuarios que buscan cobertura completa'
    ],
    compatibleCon: ['Terapia APAP', 'Terapia CPAP', 'Respiración bucal']
  },
  // ResMed Nasal Kit
  {
    id: 'resmed-nasal-kit',
    name: 'Kit ResMed Nasal',
    marca: 'ResMed',
    tipo: 'Nasal',
    descripcion: 'Kit completo con equipo AirSense 10 AutoSet y mascarilla nasal AirFit N20 para terapia CPAP premium.',
    imagen: 'https://buno1storage1account.blob.core.windows.net/www-buno/buno-tu-companero-cpap-35/airsense-10-apap-n20.png',
    shopifyHandle: 'cpap-auto-airsense-10-mascarilla-nasal-airfit-n20',
    bundleMapping: {
      equipmentId: 'resmed-airsense-10',
      maskId: 'resmed-airfit-n20',
      shopifyHandle: 'cpap-auto-airsense-10-mascarilla-nasal-airfit-n20',
      variants: {
        S: '46690770583764',
        M: '46690770616532',
        L: '46690770649300'
      }
    },
    components: [
      {
        id: 'airsense-10-autoset',
        name: 'AirSense 10 AutoSet',
        type: 'equipo',
        marca: 'ResMed',
        modelo: 'AirSense 10 AutoSet',
        caracteristicas: [
          'Algoritmo AutoSet con detección automática',
          'Función EPR para mayor comodidad',
          'HumidAir humidificador integrado',
          'Conectividad celular y Wi-Fi',
          'Reportes myAir detallados'
        ],
        imagen: 'https://buno1storage1account.blob.core.windows.net/www-buno/buno-tu-companero-cpap-35/Airsense_20S10_20AutoSet.webp',
        conectividad: 'Wi-Fi + Celular',
        garantia: '1 año completa'
      },
      {
        id: 'airfit-n20',
        name: 'AirFit N20',
        type: 'mascarilla',
        marca: 'ResMed',
        modelo: 'AirFit N20 Nasal',
        caracteristicas: [
          'Tecnología InfinitySeal',
          'Marco minimalista',
          'Almohadilla UltraSoft',
          'Tubing giratorio 360°',
          'Campo visual despejado'
        ],
        imagen: 'https://buno1storage1account.blob.core.windows.net/www-buno/buno-tu-companero-cpap-35/N20 (Nasal) Edit.jpg',
        tipo: 'Nasal',
        compatibilidad: ['ResMed AirSense 10', 'Yuwell YH-680B']
      }
    ],
    beneficios: [
      'Tecnología ResMed con algoritmo AutoSet',
      'Mascarilla nasal de máxima comodidad',
      'Conectividad avanzada con reportes detallados',
      'Humidificación integrada para mayor confort',
      'Garantía completa de 1 año'
    ],
    recomendadoPara: [
      'Usuarios que respiran principalmente por nariz',
      'Personas que buscan Tecnología',
      'Usuarios que valoran reportes detallados'
    ],
    compatibleCon: ['Terapia APAP', 'Terapia CPAP', 'Monitoreo remoto']
  },

  // ResMed Oronasal Kit
  {
    id: 'resmed-oronasal-kit',
    name: 'Kit ResMed Oronasal',
    marca: 'ResMed',
    tipo: 'Oronasal',
    descripcion: 'Kit completo con equipo AirSense 10 AutoSet y mascarilla oronasal AirFit F20 para respiradores bucales.',
    imagen: 'https://buno1storage1account.blob.core.windows.net/www-buno/buno-tu-companero-cpap-35/airsense-10-apap-f20.png',
    shopifyHandle: 'cpap-auto-airsense-10-mascarilla-facial-airfit-f20',
    bundleMapping: {
      equipmentId: 'resmed-airsense-10',
      maskId: 'resmed-airfit-f20',
      shopifyHandle: 'cpap-auto-airsense-10-mascarilla-facial-airfit-f20',
      variants: {
        S: '46690770682068',
        M: '46690770714836',
        L: '46690770747604'
      }
    },
    components: [
      {
        id: 'airsense-10-autoset',
        name: 'AirSense 10 AutoSet',
        type: 'equipo',
        marca: 'ResMed',
        modelo: 'AirSense 10 AutoSet',
        caracteristicas: [
          'Algoritmo AutoSet con detección automática',
          'Función EPR para mayor comodidad',
          'HumidAir humidificador integrado',
          'Conectividad celular y Wi-Fi',
          'Reportes myAir detallados'
        ],
        imagen: 'https://buno1storage1account.blob.core.windows.net/www-buno/buno-tu-companero-cpap-35/Airsense_20S10_20AutoSet.webp',
        conectividad: 'Wi-Fi + Celular',
        garantia: '1 año completa'
      },
      {
        id: 'airfit-f20',
        name: 'AirFit F20',
        type: 'mascarilla',
        marca: 'ResMed',
        modelo: 'AirFit F20 Oronasal',
        caracteristicas: [
          'Tecnología InfinitySeal',
          'Cobertura completa boca y nariz',
          'Almohadilla facial UltraSoft',
          'Válvula QuietAir anti-ruido',
          'Marco flexible adaptable'
        ],
        imagen: 'https://buno1storage1account.blob.core.windows.net/www-buno/buno-tu-companero-cpap-35/F20 (Oronasal) Edit.jpg',
        tipo: 'Oronasal',
        compatibilidad: ['ResMed AirSense 10', 'Yuwell YH-680B']
      }
    ],
    beneficios: [
      'Ideal para respiradores bucales o mixtos',
      'Tecnología ResMed con AutoSet',
      'Sellado óptimo para terapia efectiva',
      'Conectividad avanzada con monitoreo',
      'Comodidad durante toda la noche'
    ],
    recomendadoPara: [
      'Usuarios que respiran por boca durante el sueño',
      'Personas con obstrucción nasal frecuente',
      'Usuarios que buscan cobertura completa'
    ],
    compatibleCon: ['Terapia APAP', 'Terapia CPAP', 'Respiración bucal']
  },

  // Yuwell Nasal Kit
  {
    id: 'yuwell-nasal-kit',
    name: 'Kit Yuwell Nasal',
    marca: 'Yuwell',
    tipo: 'Nasal',
    descripcion: 'Kit económico con equipo Yuwell YH-680B y mascarilla nasal YN-03, excelente relación calidad-precio.',
    imagen: 'https://buno1storage1account.blob.core.windows.net/www-buno/buno-tu-companero-cpap-35/yh-680b-apap-yn-03.png',
    shopifyHandle: 'cpap-auto-yh-680b-mascarilla-nasal-yn-03',
    bundleMapping: {
      equipmentId: 'yuwell-yh-680b',
      maskId: 'yuwell-yn-03',
      shopifyHandle: 'cpap-auto-yh-680b-mascarilla-nasal-yn-03',
      variants: {
        S: '46624737427668',
        M: '46624736870612',
        L: '46624737460436'
      }
    },
    components: [
      {
        id: 'yuwell-yh-680b',
        name: 'Yuwell YH-680B',
        type: 'equipo',
        marca: 'Yuwell',
        modelo: 'YH-680B APAP',
        caracteristicas: [
          'Algoritmo automático inteligente',
          'Función EPR básica',
          'Motor silencioso optimizado',
          'Controles intuitivos',
          'Excelente relación calidad-precio'
        ],
        imagen: 'https://buno1storage1account.blob.core.windows.net/www-buno/buno-tu-companero-cpap-35/YH680B_1.webp',
        conectividad: 'Bluetooth',
        garantia: '1 año'
      },
      {
        id: 'yuwell-yn-03',
        name: 'Yuwell YN-03',
        type: 'mascarilla',
        marca: 'Yuwell',
        modelo: 'YN-03 Nasal',
        caracteristicas: [
          'Liviana y práctica',
          'Almohadilla nasal cómoda',
          'Fácil limpieza y mantenimiento',
          'Compatible con mayoría de equipos',
          'Ideal para usuarios nuevos'
        ],
        imagen: 'https://buno1storage1account.blob.core.windows.net/www-buno/buno-tu-companero-cpap-35/YN-03 (Nasal).webp',
        tipo: 'Nasal',
        compatibilidad: ['Yuwell YH-680B', 'ResMed AirSense 10']
      }
    ],
    beneficios: [
      'Excelente opción para comenzar terapia CPAP',
      'Precio accesible sin comprometer calidad',
      'Operación silenciosa para mejor descanso',
      'Fácil uso y mantenimiento',
      'Ideal para presupuestos ajustados'
    ],
    recomendadoPara: [
      'Usuarios nuevos en terapia CPAP',
      'Personas con presupuesto limitado',
      'Usuarios que buscan simplicidad'
    ],
    compatibleCon: ['Terapia APAP', 'Terapia CPAP', 'Usuarios principiantes']
  },

  // Yuwell Oronasal Kit
  {
    id: 'yuwell-oronasal-kit',
    name: 'Kit Yuwell Oronasal',
    marca: 'Yuwell',
    tipo: 'Oronasal',
    descripcion: 'Kit económico con equipo Yuwell YH-680B y mascarilla oronasal YF-02 para respiradores bucales.',
    imagen: 'https://buno1storage1account.blob.core.windows.net/www-buno/buno-tu-companero-cpap-35/yh-680b-apap-yf-02.png',
    shopifyHandle: 'cpap-auto-yh-680b-mascarilla-facial-yf-02',
    bundleMapping: {
      equipmentId: 'yuwell-yh-680b',
      maskId: 'yuwell-yf-02',
      shopifyHandle: 'cpap-auto-yh-680b-mascarilla-facial-yf-02',
      variants: {
        S: '46690770485460',
        M: '46690770518228',
        L: '46690770550996'
      }
    },
    components: [
      {
        id: 'yuwell-yh-680b',
        name: 'Yuwell YH-680B',
        type: 'equipo',
        marca: 'Yuwell',
        modelo: 'YH-680B APAP',
        caracteristicas: [
          'Algoritmo automático inteligente',
          'Función EPR básica',
          'Motor silencioso optimizado',
          'Controles intuitivos',
          'Excelente relación calidad-precio'
        ],
        imagen: 'https://buno1storage1account.blob.core.windows.net/www-buno/buno-tu-companero-cpap-35/YH680B_1.webp',
        conectividad: 'Bluetooth',
        garantia: '1 año'
      },
      {
        id: 'yuwell-yf-02',
        name: 'Yuwell YF-02',
        type: 'mascarilla',
        marca: 'Yuwell',
        modelo: 'YF-02 Oronasal',
        caracteristicas: [
          'Cobertura completa boca y nariz',
          'Buen sellado para terapia efectiva',
          'Diseño versátil para diferentes rostros',
          'Precio accesible',
          'Fácil mantenimiento'
        ],
        imagen: 'https://buno1storage1account.blob.core.windows.net/www-buno/buno-tu-companero-cpap-35/YF-02 (Oronasal).webp',
        tipo: 'Oronasal',
        compatibilidad: ['Yuwell YH-680B', 'ResMed AirSense 10']
      }
    ],
    beneficios: [
      'Solución completa para respiradores bucales',
      'Precio accesible con buena calidad',
      'Fácil adaptación para usuarios nuevos',
      'Cobertura total para terapia efectiva',
      'Mantenimiento sencillo y económico'
    ],
    recomendadoPara: [
      'Respiradores bucales con presupuesto limitado',
      'Usuarios nuevos que necesitan cobertura completa',
      'Personas que buscan funcionalidad básica'
    ],
    compatibleCon: ['Terapia APAP', 'Terapia CPAP', 'Respiración bucal']
  }
];

// Helper function to get kits filtered by recommendation
export const getRecommendedKits = (maskRecommendation?: string): Kit[] => {
  if (!maskRecommendation) return kits;
  return kits.filter(kit => kit.tipo === maskRecommendation);
};

// Helper function to get a specific kit by ID
export const getKitById = (id: string): Kit | undefined => {
  return kits.find(kit => kit.id === id);
};